import http from '@/http'
import createCrudModule from 'vuex-crud'
import { withDataFilter } from '@/store/index'

const store = createCrudModule({
  client: http,
  resource: 'sites/scripts',
  urlRoot: 'sites/scripts',

  state: {
    total: 0,
  },

  parseList(response) {
    return Object.assign({}, response, {
      data: response.data.data,
      total: response.data.total,
    })
  },

  onFetchListSuccess(state, response) {
    state.total = response.total
  },

  mutations: {
    updateComplete(state) {
      state.isUpdating = false
    },
  },
  actions: {
    // TODO: Ensure server logic
    update({ commit }, { id, data, config } = {}) {
      commit('updateStart')
      return http
        .post(`/sites/scripts/${id}`, data, config)
        .then(res => {
          commit('updateSuccess', res)
          return res
        })
        .catch(err => {
          commit('updateError', err)
          return Promise.reject(err)
        })
    }
  }
})



export default withDataFilter(store)
